var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 3,
    viewBox: "0 0 14 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74995 2.88867C7.5477 2.88867 8.1944 2.24197 8.1944 1.44423C8.1944 0.646485 7.5477 -0.000214577 6.74995 -0.000214577C5.95221 -0.000214577 5.30551 0.646485 5.30551 1.44423C5.30551 2.24197 5.95221 2.88867 6.74995 2.88867ZM1.69444 2.88867C2.49219 2.88867 3.13889 2.24197 3.13889 1.44423C3.13889 0.646485 2.49219 -0.000214577 1.69444 -0.000214577C0.896699 -0.000214577 0.25 0.646485 0.25 1.44423C0.25 2.24197 0.896699 2.88867 1.69444 2.88867ZM11.8056 2.88867C12.6033 2.88867 13.25 2.24197 13.25 1.44423C13.25 0.646485 12.6033 -0.000214577 11.8056 -0.000214577C11.0078 -0.000214577 10.3611 0.646485 10.3611 1.44423C10.3611 2.24197 11.0078 2.88867 11.8056 2.88867Z",
    fill: "#757575"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.8e7e901ef2337a2ed01f9750ef298e2b.svg";
export { ForwardRef as ReactComponent };